import moment from 'moment';
import schema from './schema';

import { cloneObject, addMaskCpf, addMaskPis, addMaskSus } from '../../../../utils';

const DATE_FORMAT = 'MM/DD/YYYY h:mm:ss';

function translateToSchema(response) {
    const dataBeneficiario = cloneObject(schema);

    dataBeneficiario.birth.value = moment(response.dtNascimento, DATE_FORMAT).toISOString();
    dataBeneficiario.cpf.value = addMaskCpf(response.cpf);
    dataBeneficiario.cpf.unmaskedValue = response.cpf?.replace(/\W/g, '');
    dataBeneficiario.civilState.value = response.estadoCivil.codigo && response.estadoCivil.codigo.toString();
    dataBeneficiario.civilState.lookup = response.estadoCivil.nome;
    dataBeneficiario.dn.value = response.numDeclaracaoNascidoVivo;
    dataBeneficiario.enrollmentSequence.value = response.numSequencialMatriculaEmpresa;
    dataBeneficiario.fullName.value = response.nomeCompleto;
    dataBeneficiario.functionalEnrollment.value = response.numMatriculaEmpresa;
    dataBeneficiario.gender.value = response.sexo;
    dataBeneficiario.gender.lookup = response.sexo === 'M' ? 'Masculino' : 'Feminino';
    dataBeneficiario.kinshipDegree.value = response.dependencia?.codigo;
    dataBeneficiario.kinshipDegree.lookup = response.dependencia?.nome;
    dataBeneficiario.motherName.value = response.nomeMae;
    dataBeneficiario.pis.value = addMaskPis(response.numPis);
    dataBeneficiario.pis.unmaskedValue = response.numPis;
    dataBeneficiario.socialName.value = response.nomeSocial;
    dataBeneficiario.sus.value = addMaskSus(response.numSus);
    dataBeneficiario.sus.unmaskedValue = response.numSus;
    dataBeneficiario.weddingDate.value =
        response.estadoCivil.dataCasamento && moment(response.estadoCivil.dataCasamento, DATE_FORMAT).toISOString();

    const residencial = response.enderecos?.length > 0 ? response.enderecos[0] : {};

    dataBeneficiario.stateService.value = residencial?.ufAtendimento;
    dataBeneficiario.stateService.lookup = residencial?.ufAtendimento; // TODO: must be the nam.
    dataBeneficiario.countyService.value = residencial?.codigoMunicipioAtendimento;
    dataBeneficiario.countyService.lookup = residencial?.nomeMunicipioAtendimento;
    dataBeneficiario.congenerName.value = '';

    return dataBeneficiario;
}

export default translateToSchema;
